import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Theme } from "@mui/material";
import { useAppDispatch } from "@/Redux/Redux";
import { TOGGLE_ARRIVING_VEHICLES } from "@/Redux/Disposition/Constants";
import { RootStateOrAny, useSelector } from "react-redux";
import { selectShowArrivingVehicles } from "@/Redux/Disposition/DispositionReducer";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface DispositionLineProps {
    lineItem: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    stationGroup: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        marginTop: 20,
        paddingLeft: 15,
    },

    stationGroupHeadLine: {
        marginTop: 0,
        fontSize: "1rem",
        fontWeight: 700,
        marginBottom: 13,
    },

    stationGroupToggle: {
        marginRight: 5,
        fontWeight: 400,
        cursor: "pointer",
    },

    cropTitle: {
        textOverflow: "ellipsis",
        width: 200,
        display: "inline-block",
        position: "absolute",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },

    stationInfoIcon: {
        fontSize: 17,
        cursor: "pointer",
        position: "absolute",
        marginRight: 5,
        left: 277,
        fontWeight: 400,
    },

    hideCarsIcon: {
        fontSize: 17,
        cursor: "pointer",
        position: "absolute",
        marginRight: 5,
        left: 249,
        fontWeight: 400,
    },

    dragBox: {
        height: "100%",
        position: "absolute",
        right: 0,
        top: 0,
    },
}));

const ArrivingVehicles: FunctionComponent<DispositionLineProps> = ({
    lineItem,
}): JSX.Element => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const showArrivingVehicles = useSelector((state) =>
        selectShowArrivingVehicles(state as RootStateOrAny),
    );
    return (
        <>
            <div className={classes.stationGroup}>
                <h5 className={classes.stationGroupHeadLine}>
                    <span
                        data-id={lineItem.stationId}
                        className={classes.stationGroupToggle}
                        onClick={() => {
                            dispatch({ type: TOGGLE_ARRIVING_VEHICLES });
                        }}
                    >
                        {showArrivingVehicles ? (
                            <KeyboardArrowDownIcon
                                style={{ fontWeight: 400 }}
                            />
                        ) : (
                            <KeyboardArrowUpIcon style={{ fontWeight: 400 }} />
                        )}
                    </span>
                    <span className={classes.cropTitle}>
                       
                        {t("disposition.incomingVehicles")}
                    </span>
                </h5>
            </div>
        </>
    );
};

export default React.memo(ArrivingVehicles);
